export const surveyQuestions = [
  { id: 1, category: 'Ownership', text: 'R&R이 모호한 업무가 있으면 남이 아닌 내가 한다는 자세로 직접 발로 뛴다.' },
  { id: 2, category: 'Ownership', text: '시장에서 기대할 수 있는 수준 이상의 보이지 않는 기준을 스스로 만들어 일한다.' },
  { id: 3, category: 'Ownership', text: '당장 돋보이는 형식적 업무에 매몰되지 않고 본질적 성과를 위해 묵묵히 일한다.' },
  { id: 4, category: 'Co-work', text: '조직 공동의 목표 달성을 위해 내 지식과 리소스를 아낌없이 공유한다.' },
  { id: 5, category: 'Co-work', text: '상호 존중의 커뮤니케이션으로 갈등을 원만하게 해결하고 긍정적인 협업 분위기를 유도한다.' },
  { id: 6, category: 'Co-work', text: '타인의 피드백을 열린 마음으로 수용하며 동료의 성장을 위해 적극 돕는다.' },
  { id: 7, category: 'Professionalism', text: '전문적인 지식과 기술력을 끊임없이 고도화하여 담당 과업의 품질을 높인다.' },
  { id: 8, category: 'Professionalism', text: '돌발적인 이슈나 어려운 대내외 환경에서도 끝까지 주도적으로 책임을 완수한다.' },
  { id: 9, category: 'Professionalism', text: '사적 감정이나 관성적 판단을 지양하고 합리적인 원칙과 사실에 기반하여 의사결정한다.' },
] as const;

export const surveyCategoryMeta = {
  Ownership: { title: '주인의식 (Ownership)', desc: '남이 아닌 내가 한다는 자발성과 높은 성과 창출 기준' },
  'Co-work': { title: '협업 및 팀워크 (Teamwork / Co-work)', desc: '지식 공유와 상호 존중을 통한 시너지 창출 유도력' },
  Professionalism: { title: '전문성 (Professionalism)', desc: '전문 지식 고도화 및 끝까지 완수해내는 실천 능력' },
} as const;

export type SurveyCategory = keyof typeof surveyCategoryMeta;
